module.exports = __webpack_public_path__ + "static/media/03-gallery1.4566ebfb.png";